export const passwordValidation = password => {
  return password.match(
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9~`)({}+!#$%^&*@_]{8,})$/
  );
};
